export default __webpack_public_path__ + "static/press-awards-desmoines-a1574ecd9f4320702c538667c20d3eb0.jpg";